<template>
  <v-container fluid class="fields-table">
    <loader :show="$anyLoading()" :message="messageLoader"></loader>
    <confirm-modal
      :dialog="showConfirm"
      :message="confirmMessage"
      @confirm="confirmResponse($event)"></confirm-modal>
    <v-layout row wrap>
      <v-flex xs6 md5 offset-md1 d-flex align-center>
        <h4 class="green--text headline mb-0">Canchas</h4>
      </v-flex>
      <v-flex xs6 md5 text-xs-right>
        <v-tooltip left>
          <v-btn
            v-on:click="goNewField()"
            dark
            color="green"
            slot="activator"
            fab
            small>
              <v-icon>add</v-icon>
            </v-btn>
          <span>Nueva Cancha</span>
        </v-tooltip>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex xs12 md10 offset-md1>
        <v-text-field
          box
          name="searchbar"
          label="Buscar canchas"
          append-icon="search"
          class="white--text"
          v-model="filter"></v-text-field>
      </v-flex>
      <v-flex xs12 md10 offset-md1>
        <v-data-table
          :rows-per-page-items="[25,50,100]"
          :headers="headers"
          :items="currentFields"
          :search="filter"
          class="elevation-1 responsive-table datatable-condensed"
          light
          :loading="tableLoading"
          >
          <template slot="items" slot-scope="props">
            <td v-on:click="goEditField(props.item.id)"
              class="text-xs-left green--text cursor-pointer sticky-cell">
              <span class="crop-text">
                {{ props.item.name }}
              </span>
            </td>
            <td class="text-xs-left grey--text">
              <v-tooltip left>
                <v-switch
                  v-model="props.item.active"
                  light
                  color="green"
                  @click="disableField($event, props.item)"
                  slot="activator">
                  </v-switch>
                  <span>{{ props.item.active ? 'Habilitado' : 'Inhabilitado' }}</span>
              </v-tooltip>
            </td>
            <td class="text-xs-left">
              <v-tooltip left>
                <v-btn
                    @click="deleteField($event, props.item)"
                    flat
                    icon
                    light
                    slot="activator">
                  <v-icon>delete</v-icon>
                </v-btn>
                <span>Eliminar Cancha</span>
              </v-tooltip>
            </td>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/utils/utils'

export default {
  name: "Fields",
  data: () => ({
    messageLoader: 'Cargando Información',
    actionSelected: '',
    fieldSelected: [],
    filter: '',
    showConfirm: false,
    confirmMessage: '¿Estas seguro que quieres inhabilitar la cancha?',
    tableLoading: false,
    fields: [],
    headers: [
      { text: 'Nombre', value: 'name', align: 'left' },
      { text: 'Estado', value: 'status', align: 'left' },
      { text: '', value: 'delete', align: 'left' }
    ],
    items: [
      {
        name: 'Cancha 01',
        status: true
      },
      {
        name: 'Cancha 02',
        status: false
      }
    ]
  }),
  created() {
    //do something after creating vue instance
    this.loadFields()
  },
  computed:{
    ...mapGetters([
      'currentFields'
    ]),
    ...mapGetters('loading', [
      'isLoading',
      'anyLoading',
    ])
  },
  methods: {
    ...mapActions([
      'loadFields',
      'goNewField',
      'goEditField',
      'removeField',
      'activeField'
    ]),
    disableField(event, field) {
      this.actionSelected = 'disableField'
      this.fieldSelected = field
      let msg1 = '¿Estas seguro que quieres inhabilitar la cancha?'
      let msg2 = '¿Estas seguro que quieres habilitar la cancha?'
      this.confirmMessage = field.active ? msg1 : msg2
      this.showConfirm = true
    },

    deleteField(event, field) {
      this.fieldSelected = field
      this.actionSelected = 'deleteField'
      this.confirmMessage = '¿Estas seguro que quieres borrar la cancha?'
      this.showConfirm = true
    },

    confirmResponse(response) {
      if(response){
        //En caso la respuesta del usuario sea positiva
        if(this.actionSelected === 'disableField'){
          this.activeField(this.fieldSelected)
        }else if(this.actionSelected === 'deleteField'){
          this.removeField(this.fieldSelected)
        }

      }else {
        //En caso la respuesta del usuario sea negativa
      }
      this.showConfirm = false
    }
  },
  mounted() {
    Utils.setTableOverflowClass('.responsive-table');
  },
}
</script>
<style lang="scss">
@import "src/assets/scss/tables-placeholder-selectors";

.fields-table {
  th:first-child,
  .sticky-cell {
    @extend %sticky-cell;
    top: auto;
    left: 0;
  }

  .has-scroll th:first-child,
  .has-scroll .sticky-cell {
    @extend %sticky-cell-has-shadow;
  }

  @media screen and (max-width: $mobile-md-breakpoint) {
    .btn {
      margin: 0;
    }

    .datatable.table td.button-cell {
      padding: 0;
    }
  }

  .btn.btn--flat {
    margin: 0;
    width: 24px;
    height: 24px;
  }

  .btn .material-icons {
    font-size: 19px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/fields/fields.vue